import { c as _c } from "react/compiler-runtime";
import makeBlockie from 'ethereum-blockies-base64';
import { useMemo, useState } from 'react';
import type { Wallet } from '@/modules/networks/components/wallets-section/wallets-section';
import { addressShortener, calculateTotalBalance } from '@/modules/networks/lib/wallets-card-utils';
interface UseWalletsCardProps {
  wallets: Wallet[];
}
export interface ProccesedWallets extends Wallet {
  image: string;
  shortAddress: string;
}
export function useWalletsCard(t0) {
  const $ = _c(14);
  const {
    wallets
  } = t0;
  const [toogleWalletTable, setToogleWalletTable] = useState(true);
  let t1;
  if ($[0] !== wallets) {
    t1 = wallets.map(_temp);
    $[0] = wallets;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const proccesedWallets = t1;
  let t2;
  if ($[2] !== toogleWalletTable) {
    t2 = () => {
      setToogleWalletTable(!toogleWalletTable);
    };
    $[2] = toogleWalletTable;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleToogleWalletTable = t2;
  let t3;
  if ($[4] !== wallets) {
    t3 = calculateTotalBalance({
      wallets,
      balanceKey: "usdsBalance"
    });
    $[4] = wallets;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const usdsTotalBalance = t3;
  let t4;
  if ($[6] !== wallets) {
    t4 = calculateTotalBalance({
      wallets,
      balanceKey: "skyBalance"
    });
    $[6] = wallets;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const skyTotalBalance = t4;
  let t5;
  if ($[8] !== handleToogleWalletTable || $[9] !== proccesedWallets || $[10] !== skyTotalBalance || $[11] !== toogleWalletTable || $[12] !== usdsTotalBalance) {
    t5 = {
      proccesedWallets,
      toogleWalletTable,
      usdsTotalBalance,
      skyTotalBalance,
      handleToogleWalletTable
    };
    $[8] = handleToogleWalletTable;
    $[9] = proccesedWallets;
    $[10] = skyTotalBalance;
    $[11] = toogleWalletTable;
    $[12] = usdsTotalBalance;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function _temp(wallet) {
  return {
    ...wallet,
    image: makeBlockie(wallet.address),
    shortAddress: addressShortener(wallet.address)
  };
}